import React from "react";
import GlobalNav from "../components/GlobalNav";
import Footer from "../components/Footer";
import "../styles/buttons.css";
import "./CatalogPage.css";

// Full content preserved from catalog.handlebars, translated to the
// current theme -- nothing trimmed. Two things worth knowing:
//
// 1. The two PDF tiles (Release Catalogue, Services PDF) had dead "#"
//    href attributes even in the ORIGINAL source file -- these were never
//    functional, not something removed during migration. Kept visible
//    since "don't trim" applies to real content, but not linked to
//    anywhere fake. Add real file URLs here once the PDFs actually exist.
//
// 2. The original's sidebar nav (Distribution, Artist Registry, Contact
//    Us, Terms & Conditions, Cookies, Privacy Policy) and its footer were
//    both wrapped in Handlebars comments in the source -- meaning even
//    the original author had them switched off, not rendering live. Not
//    resurrected here, since restoring commented-out code would make this
//    page MORE complete than the actual original ever was.
export default function CatalogPage() {
  return (
    <div className="catalog-page">
      <GlobalNav activeHref="/catalog" ctaLabel="Join the collective" />

      <div className="catalog-hero">
        <img
          className="catalog-hero-image"
          src="/images/mtshasta.jpg"
          alt=""
        />
        <div className="catalog-hero-overlay">
          <h1>Catalog &amp; Music Sales</h1>
        </div>
      </div>

      <div className="catalog-body">
        <div className="catalog-contact-card">
          <div className="catalog-contact-label">Music sales &amp; artist booking</div>
          <div className="catalog-contact-name">Pierre Tchetgen</div>
          <a className="catalog-contact-line" href="tel:+15413637920">+1 (541) 363-7920</a>
          <a className="catalog-contact-line" href="mailto:sales@musicishealing.us">sales@musicishealing.us</a>
        </div>

        <div className="catalog-contact-card">
          <div className="catalog-contact-label">Riddims &amp; production enquiries</div>
          <div className="catalog-contact-name">Derek Wood</div>
          <a className="catalog-contact-line" href="tel:+16179687375">+1 (617) 968-7375</a>
          <a className="catalog-contact-line" href="mailto:studio@musicishealing.us">studio@musicishealing.us</a>
        </div>

        <p className="catalog-intro">
          Or you can review our latest releases catalogue at your leisure, by
          downloading our PDF print brochure below.
        </p>

        <div className="catalog-tiles">
          <div className="catalog-tile catalog-tile--pending">
            <div className="catalog-tile-icon">⬇</div>
            <h3>Release Catalogue : PDF</h3>
            <p>View our latest catalogue</p>
            <span className="catalog-tile-note">Not yet available</span>
          </div>

          <div className="catalog-tile catalog-tile--pending">
            <div className="catalog-tile-icon">📄</div>
            <h3>Music Is Healing Services : PDF</h3>
            <p>See what we can do for your project</p>
            <span className="catalog-tile-note">Not yet available</span>
          </div>
        </div>

        <div className="catalog-affiliates">
          <span>Registered with</span>
          <span className="catalog-affiliate-name">SoundExchange</span>
          <span>&amp;</span>
          <span className="catalog-affiliate-name">ASCAP</span>
        </div>
      </div>

      <Footer />
    </div>
  );
}
